export default __webpack_public_path__ + "b3611697434ac7d8217cb25c22a71f38.jpg";